import job_search_tabular_0 from "file:///home/wldocker/wl-cms/sites/modules/job-search-tabular-widget/ui/src/job-search-tabular.js";



import job_search_tabular_0Stylesheet from "file:///home/wldocker/wl-cms/sites/modules/job-search-tabular-widget/ui/src/job-search-tabular.scss";job_search_tabular_0();